import {
  CANCEL_SUBSCRIPTION,
  CLEAN_UPDATE_SUBSCRIPTION,
  GET_PADDLE_PRICES,
  GET_PADDLE_PRODUCTS,
  GET_USER_PAYMENT_METHOD,
  GET_USER_TRANSACTIONS,
  SET_PADDLE_LOADING,
  SET_UPDATE_SUBSCRIPTION,
  UPDATE_PAYMENT_METHOD,
  UPDATE_SUBSCRIPTION,
} from './paddleTypes';

const initialState = {
  loading: false,
  products: null,
  prices: null,
  isUpdate: false,
  userTransactions: null,
  paymentMethod: null,
};

const PaddleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PADDLE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_PADDLE_PRODUCTS:
      return {
        ...state,
        products: action.payload,
        loading: false,
      };
    case GET_PADDLE_PRICES:
      return {
        ...state,
        prices: action.payload,
        loading: false,
      };
    case UPDATE_SUBSCRIPTION:
      return {
        ...state,
        loading: false,
        isUpdate: false,
      };
    case SET_UPDATE_SUBSCRIPTION:
      return {
        ...state,
        isUpdate: true,
      };
    case CLEAN_UPDATE_SUBSCRIPTION:
      return {
        ...state,
        isUpdate: false,
      };
    case GET_USER_TRANSACTIONS:
      return {
        ...state,
        userTransactions: action.payload,
        loading: false,
      };
    case GET_USER_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
        loading: false,
      };
    case CANCEL_SUBSCRIPTION:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PAYMENT_METHOD:
      return {
        ...state,
        loading: false,
      };
    default:
      return { ...state };
  }
};

export default PaddleReducer;
